export default __webpack_public_path__ + "static/cukrzyca_logo-4d6d7a5268cd821617c07d9f4e1b3add.svg";